import { useCart } from "context/cart/CartContext";
import { useCatalog } from "context/catalog/CatalogContext";
import { useUi } from "context/ui/UIContext";
import { ICheckStockResponse } from "models/inventory/ICheckStock";
import { useCallback, useEffect, useState } from "react"
import { useHistory, useParams } from "react-router";
import InventoryApi from "services/Api/inventory/InventoryApi";
import SendOrderApi from "services/Api/order/SendOrderApi"
import { v4 } from "uuid";

const UseCartPage = () => {
    const { cartItems, totals, updateCartLocalStorage } = useCart();
    const { showLoading, hideLoading } = useUi();
    const { catalog } = useCatalog();
    const { push } = useHistory();
    const { url } = useParams<{ url: string }>()

    const [stockResult, setStockResult] = useState<ICheckStockResponse | null>(null);
    const [isCheckingStock, setIsCheckingStock] = useState(false);

    useEffect(() => {
        if (!cartItems.length) {
            setStockResult(null);
            return;
        }

        setIsCheckingStock(true);
        InventoryApi().checkStock({
            products: cartItems.map(item => ({ productId: item.productId, quantity: item.quantity }))
        })
            .then(({ data }) => setStockResult(data))
            .catch(() => setStockResult(null))
            .finally(() => setIsCheckingStock(false));
    }, [cartItems]);

    const sendPreOrder = useCallback(() => {
        const newOrderId = v4();
        const newOrder = {
            id: newOrderId,
            items: cartItems,
            total: totals.totalPrice,
        }
        const sendOrder = SendOrderApi();
        if (catalog) {
            showLoading();
            updateCartLocalStorage(cartItems)
            sendOrder.sendPreOrder(newOrder, catalog.id).then((response) => {
                if (window.fbq) {
                    window.fbq("track", "InitiateCheckout", {
                        content_ids: newOrderId,
                        num_items: cartItems.reduce((acc, item) => acc + item.quantity, 0),
                        value: totals.totalPrice,
                        contents: [cartItems.map(item => ({ id: item.productId, quantity: item.quantity, name: item.name }))]
                    });
                }

                if (catalog.isMeepCard) {
                    push(`/${url}/selecionarPagamento?localId=${catalog.id}&orderId=${response.data.pedidoId}`);
                } else {
                    push(`/${url}/payment?orderId=${response.data.pedidoId}`);
                }
            }).finally(() => {
                hideLoading();
            })
        }
    }, [cartItems, totals.totalPrice, catalog, showLoading, updateCartLocalStorage, push, url, hideLoading])

    return {
        sendPreOrder,
        stockResult,
        isCheckingStock,
    }
}
export default UseCartPage
